import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface IActionableDialogPayload {
  open: boolean
  threadId?: string | null
  assigneeId?: string | null
  isChangeToActionable?: boolean
}
interface ActionableCommentStore {
  // State
  actionableDialogOpen: boolean
  notActionableDialogOpen: boolean
  threadId: string | null
  assigneeId: string | null
  isCheckingSync: boolean
  isChangeToActionable: boolean

  // Actions
  setActionableDialogOpen: (payload: IActionableDialogPayload) => void
  setNotActionableDialogOpen: (open: boolean, threadId?: string | null) => void

  setIsCheckingSync: (isCheckingSync: boolean) => void
  reset: () => void
}

const initialState = {
  actionableDialogOpen: false,
  notActionableDialogOpen: false,
  threadId: null,
  assigneeId: null,
  isCheckingSync: false,
  isChangeToActionable: false,
}

export const useActionableCommentStore = create<ActionableCommentStore>()(
  devtools(
    (set) => ({
      ...initialState,

      /**
       * Set the actionable dialog open status
       * @param payload - The actionable dialog payload
       */
      setActionableDialogOpen: (payload: IActionableDialogPayload) => {
        const {
          open,
          threadId = null,
          assigneeId = null,
          isChangeToActionable = false,
        } = payload
        set(
          {
            actionableDialogOpen: open,
            threadId,
            assigneeId,
            isChangeToActionable,
          },
          false,
          'setActionableDialogOpen'
        )
      },

      /**
       * Set the not actionable dialog open status
       * @param open - The not actionable dialog open status
       * @param threadId - The thread ID
       */
      setNotActionableDialogOpen: (
        open: boolean,
        threadId: string | null = null
      ) => {
        set(
          { notActionableDialogOpen: open, threadId },
          false,
          'setNotActionableDialogOpen'
        )
      },

      /**
       * Set the checking sync status
       * @param isCheckingSync - The checking sync status
       */
      setIsCheckingSync: (isCheckingSync: boolean) => {
        set({ isCheckingSync }, false, 'setIsCheckingSync')
      },

      reset: () => {
        set(initialState, false, 'reset')
      },
    }),
    {
      name: 'ActionableCommentStore',
    }
  )
)
